import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";

@Component({
  selector: "app-infra-jobs",
  templateUrl: "./infra-jobs.component.html",
  styleUrls: ["./infra-jobs.component.css"],
  providers: [RestService],
})
export class InfraJobsComponent implements OnInit {
  isShown: boolean = false;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  isLoading: boolean = false;

  isJobNameSorted: boolean = false;
  isAliasSorted: boolean = false;
  isIDSorted: boolean = false;
  isPathSorted: boolean = false;
  isOccurrencesSorted: boolean = false;
  isjobDetailPage: boolean = false;
  isjobListPage: boolean = true;
  joboccurrences: boolean = false;
  jobSeriesDetails: boolean = false;
  botName: any = "";

  successMessage: any = "";
  failureMessage: any = "";
  envList: any = "";
  default_envronment_id: any = "";
  botid: any = "";
  actualArray: any = [];
  filterArray: any = [];
  searchArray: any = [];
  data: any = [];
  masterEnvId: any = "";

  pageSize: any = 0;
  boxSize: any = 0;
  minValue: any = 0;
  maxValue: any = 0;
  prevValue: any = 0;
  totalJobsCount: number = 0;
  paginationLength: number = 0;
  seriesOnly = false;

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.default_envronment_id = f.EnvList[0].id),
          (this.envList = f.EnvList),
          this.envList.filter((m: any) =>
            parseInt(m.id) === parseInt(this.default_envronment_id)
              ? (this.masterEnvId = m.MasterEnvId)
              : ""
          ),
          console.log("this.envList ---->>>", this.envList),
          this._restService
            .getBotsActivity(this.default_envronment_id, this.masterEnvId)
            .pipe(
              catchError((e) => {
                (this.isLoading = false),
                  (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                return e;
              })
            )
            .subscribe(
              (d: any) => (
                console.log("getBotsActivity", d),
                (this.actualArray = d.botActivityRes),
                (this.data = d.botActivityRes),
                (this.totalJobsCount =
                  parseFloat(d.botActivityRes.length) / 10),
                (this.paginationLength =
                  this.totalJobsCount % 1 === 0
                    ? Math.round(this.totalJobsCount)
                    : Math.round(this.totalJobsCount) + 1),
                this.loopingPagination(d.botActivityRes.length),
                this.actualArray.map(
                  (f: any) => (
                    (f.occurrences =
                      f.RecuringTotal === undefined
                        ? f.SScheduleCount + 0
                        : f.SScheduleCount + f.RecuringTotal),
                    f.Alias === null ? (f.Alias = "") : ""
                  )
                ),
                this.actualArray.map((f: any, index: any) =>
                  index + 1 <= 10 ? this.filterArray.push(f) : ""
                ),
                (this.isLoading = false),
                //(this.filterArray = this.actualArray),
                console.log("Maari Yes --->", this.actualArray)
              )
            )
        )
      );
  }

  changeSeriesFlag(value: boolean){
    this.seriesOnly = value;
  }

  loopingPagination(l: any) {
    this.minValue = 1;
    this.maxValue = l > 10 ? 10 : l;
    this.pageSize = l;
    this.prevValue = 0;
    console.log("pageSize", this.pageSize);
  }

  nextpage(c: any, type: any) {
    let pageSize = this.pageSize;
    this.minValue = c + 1;
    this.maxValue = c + 10 >= pageSize ? pageSize : c + 10;
    this.prevValue = c;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.pageSize);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  prevpage(p: any, type: any) {
    this.minValue = p - 10 + 1;
    this.maxValue = p;
    this.prevValue = p - 10;

    console.log(this.minValue + "---" + this.maxValue + "---" + this.prevValue);

    type === "normal"
      ? ((this.filterArray = []),
        this.actualArray.map((f: any, index: any) =>
          index + 1 >= this.minValue && index + 1 <= this.maxValue
            ? this.filterArray.push(f)
            : ""
        ))
      : "";
  }

  searchKeyword(e: any) {
    if (e.target.value === "") {
      (this.filterArray = []),
        (this.actualArray = []),
        (this.actualArray = this.data),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.actualArray.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      let v = e.target.value.toLowerCase();

      this.searchArray = [];
      this.filterArray = [];

      this.actualArray = this.data;

      this.actualArray.map((f: any) =>
        f.BotName.toLowerCase().includes(v) ||
        f.BotPath.toLowerCase().includes(v) ||
        f.BotId.toString().includes(v) ||
        f.Alias.toLowerCase().includes(v) ||
        f.occurrences.toString().includes(v)
          ? this.searchArray.push(f)
          : ""
      ),
        (this.actualArray = []),
        (this.actualArray = this.searchArray),
        (this.totalJobsCount = parseFloat(this.actualArray.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(this.actualArray.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
      //this.filterArray = this.searchArray;
    }
  }

  selectEnvironment(e: any) {
    let environmentID: any = e.target.value;

    this.default_envronment_id = environmentID;

    this.envList.filter((m: any) =>
      parseInt(m.id) === parseInt(environmentID)
        ? (this.masterEnvId = m.MasterEnvId)
        : ""
    );

    this.filterArray = [];
    (this.isLoading = true),
      this._restService
        .getBotsActivity(environmentID, this.masterEnvId)
        .pipe(
          catchError((e) => {
            (this.isLoading = false),
              (this.isFailure = true),
              (this.failureMessage = e.error.StatusInfo);
            return e;
          })
        )
        .subscribe(
          (d: any) => (
            console.log("getBotsActivity", d),
            (this.actualArray = d.botActivityRes),
            (this.data = d.botActivityRes),
            (this.totalJobsCount = parseFloat(d.botActivityRes.length) / 10),
            (this.paginationLength =
              this.totalJobsCount % 1 === 0
                ? Math.round(this.totalJobsCount)
                : Math.round(this.totalJobsCount) + 1),
            this.loopingPagination(d.botActivityRes.length),
            this.actualArray.map(
              (f: any) => (
                (f.occurrences =
                  f.RecuringTotal === undefined
                    ? f.SScheduleCount + 0
                    : f.SScheduleCount + f.RecuringTotal),
                f.Alias === null ? (f.Alias = "") : ""
              )
            ),
            this.actualArray.map((f: any, index: any) =>
              index + 1 <= 10 ? this.filterArray.push(f) : ""
            ),
            (this.isLoading = false),
            //(this.filterArray = this.actualArray),
            console.log("Maari Yes --->", this.actualArray)
          )
        );
  }

  sortingName() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isJobNameSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.BotName.localeCompare(b.BotName);
      });
      this.isJobNameSorted = true;
      //this.filterArray = sortedList;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.BotName.localeCompare(a.BotName);
      });
      this.isJobNameSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingAlias() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isAliasSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.Alias.localeCompare(b.Alias);
      });
      this.isAliasSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.Alias.localeCompare(a.Alias);
      });
      this.isAliasSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingPath() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isPathSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.BotPath.localeCompare(b.BotPath);
      });
      this.isPathSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.BotPath.localeCompare(a.BotPath);
      });
      this.isPathSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingID() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isIDSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.BotId - b.BotId;
      });
      this.isIDSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.BotId - a.BotId;
      });
      this.isIDSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  sortingOccurrences() {
    let sortedList: any = [];
    this.filterArray = [];

    if (this.isOccurrencesSorted === false) {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return a.occurrences - b.occurrences;
      });
      this.isOccurrencesSorted = true;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    } else {
      sortedList = this.actualArray.sort(function (a: any, b: any) {
        return b.occurrences - a.occurrences;
      });
      this.isOccurrencesSorted = false;
      (this.totalJobsCount = parseFloat(sortedList.length) / 10),
        (this.paginationLength =
          this.totalJobsCount % 1 === 0
            ? Math.round(this.totalJobsCount)
            : Math.round(this.totalJobsCount) + 1),
        this.loopingPagination(sortedList.length),
        this.actualArray.map((f: any, index: any) =>
          index + 1 <= 10 ? this.filterArray.push(f) : ""
        );
    }
  }

  jobDetail(name: any, bid: any) {
    this.botName = name;
    this.botid = bid;
    this.isjobListPage = false;
    this.isjobDetailPage = true;
    localStorage.setItem("joboccurrences", "true");
    localStorage.setItem("botName", name);
    localStorage.setItem("bid", bid);
    this.joboccurrences = Boolean(localStorage.getItem("joboccurrences"));
    // this._restService
    //   .getBotOccurance(this.default_envronment_id, bid)
    //   .pipe(
    //     catchError((e) => {
    //       (this.isLoading = false),
    //         (this.isFailure = true),
    //         (this.failureMessage = e.error.StatusInfo);
    //       return e;
    //     })
    //   )
    //   .subscribe((f: any) => console.log("getBotOccurance", f));
  }

  backtojobList() {
    this.isjobListPage = true;
    this.isjobDetailPage = false;
    localStorage.setItem("joboccurrences", "false");
    this.joboccurrences = Boolean(localStorage.getItem("joboccurrences"));

    this.filterArray = [];
    this.isLoading = true;
    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isLoading = false),
            (this.isFailure = true),
            (this.failureMessage = e.error.StatusInfo);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.default_envronment_id = f.EnvList[0].id),
          (this.envList = f.EnvList),
          console.log("this.envList ---->>>", this.envList),
          this._restService
            .getBotsActivity(this.default_envronment_id, this.masterEnvId)
            .pipe(
              catchError((e) => {
                (this.isLoading = false),
                  (this.isFailure = true),
                  (this.failureMessage = e.error.StatusInfo);
                return e;
              })
            )
            .subscribe(
              (d: any) => (
                (this.actualArray = d.botActivityRes),
                (this.totalJobsCount =
                  parseFloat(d.botActivityRes.length) / 10),
                (this.paginationLength =
                  this.totalJobsCount % 1 === 0
                    ? Math.round(this.totalJobsCount)
                    : Math.round(this.totalJobsCount) + 1),
                this.loopingPagination(d.botActivityRes.length),
                this.actualArray.map(
                  (f: any) =>
                    (f.occurrences =
                      f.RecuringTotal === undefined
                        ? f.SScheduleCount + 0
                        : f.SScheduleCount + f.RecuringTotal)
                ),
                this.actualArray.map((f: any, index: any) =>
                  index + 1 <= 10 ? this.filterArray.push(f) : ""
                ),
                //(this.filterArray = this.actualArray),
                console.log("Maari --->", this.actualArray),
                (this.isLoading = false)
              )
            )
        )
      );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }
}
